import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "type", "value"]
const _hoisted_3 = {
  key: 0,
  class: "mb0 txt-danger font14 mt3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      for: _ctx.inputId,
      class: "bold"
    }, _toDisplayString(_ctx.label), 9, _hoisted_1),
    _createElementVNode("input", {
      id: _ctx.inputId,
      type: _ctx.inputType,
      value: _ctx.formattedValue,
      onInput: _cache[0] || (_cache[0] = (...args) => (_ctx.onInput && _ctx.onInput(...args))),
      onBlur: _cache[1] || (_cache[1] = (...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
      class: _normalizeClass([[{ 'outline-danger': _ctx.errorMessage}], "input"])
    }, null, 42, _hoisted_2),
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ]))
}